/* eslint-disable  */
import { DesignerSettings } from '@decisions/server/DecisionsFramework/Design';
import { ChartInfo, ChartType, ReportView } from '@decisions/server/DecisionsFramework/Design/Report';
import {
  ReportTextOutputType,
  ReportViewContext,
} from '@decisions/server/DecisionsFramework/Design/Report/Service/Comunication';
import { DataPair } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/ContextData';
import {
  ReportGridStyles,
  ReportGridType,
  ShowGroupTitleDefaultOptions,
} from '@decisions/server/Silverdark/Components/Page/ReportViewer';
import { getNavigationParams } from 'components/Router';
import {
  registerForEventAndSubscribe,
  sendClientEventNotification,
  unRegisterForEventAndUnsubscribe,
} from 'utils/ClientEventUtils';
import { getMoment, getMomentFromString, isDotNetJSONDate } from 'utils/DateTimeUtils';
import {
  GridRowClickActionType,
  ReportGridSettings,
  ReportHeaderViewItem,
  ReportViewerPart,
  ShowGroupTitleReportOptions,
} from '../reportTypes';

export function getReportGridSettings(
  reportViewerPart: ReportViewerPart,
  reportViewContext: ReportViewContext,
  designerSettings: DesignerSettings | undefined,
  isDrillDown: boolean,
  hideMaximizeButton: boolean
) {
  //Report grid style hierarchy first
  let reportGridSettings: ReportGridSettings = {} as ReportGridSettings;
  if (reportViewerPart.reportGridStyle == ReportGridStyles.Global) {
    if (reportViewContext.ReportGridType == ReportGridStyles.Global) {
      if (designerSettings?.ReportGridType == ReportGridType.Expanded)
        reportGridSettings.ReportGridType = ReportGridStyles.Expanded;
      reportGridSettings.GridIconType = designerSettings?.GridIconType;
      reportGridSettings.IsAlternateRowsBackground = designerSettings?.IsAlternateRowsBackground;
      reportGridSettings.SelectedRowsStyle = designerSettings?.SelectedRowsStyle;
      reportGridSettings.NewGridActionType = designerSettings?.NewGridActionType;
      reportGridSettings.ActionButtonName = designerSettings?.ActionButtonName;
      reportGridSettings.IsRowNumerationEnable = designerSettings?.IsRowNumerationEnable;
      reportGridSettings.ShowSelectedRowIndicator = designerSettings?.ShowSelectedRowIndicator;
      reportGridSettings.RowLeftClickActionType =
        reportViewerPart.rowLeftClickActionType == GridRowClickActionType.NoActions
          ? GridRowClickActionType.NoActions
          : designerSettings?.RowLeftClickActionType;
      reportGridSettings.RowRightClickActionType = designerSettings?.RowRightClickActionType;
      reportGridSettings.IsGroupingEnable = designerSettings?.IsGroupingEnable;
      reportGridSettings.IsSortingEnable = designerSettings?.IsSortingEnable;
      reportGridSettings.IsGridStretchModeEnable = designerSettings?.IsGridStretchModeEnable;
      reportGridSettings.RightIndicatorDisplay = designerSettings?.RightIndicatorDisplay;
    } else {
      reportGridSettings.ReportGridType = reportViewContext.ReportGridType;
      reportGridSettings.GridIconType = reportViewContext.GridIconType;
      reportGridSettings.IsAlternateRowsBackground = reportViewContext.IsAlternateRowsBackground;
      reportGridSettings.SelectedRowsStyle = reportViewContext.SelectedRowsStyle;
      reportGridSettings.NewGridActionType = reportViewContext.NewGridActionType;
      reportGridSettings.ActionButtonName = reportViewContext.ActionButtonName;
      reportGridSettings.RowLeftClickActionType =
        reportViewerPart.rowLeftClickActionType == GridRowClickActionType.NoActions
          ? GridRowClickActionType.NoActions
          : reportViewContext.RowLeftClickActionType;
      reportGridSettings.RowRightClickActionType = reportViewContext.RowRightClickActionType;
      reportGridSettings.IsRowNumerationEnable = reportViewContext.IsRowNumerationEnable;
      reportGridSettings.ShowSelectedRowIndicator = reportViewContext.ShowSelectedRowIndicator;
      reportGridSettings.IsGroupingEnable = reportViewContext.IsGroupingEnable;
      reportGridSettings.IsSortingEnable = reportViewContext.IsSortingEnable;
      reportGridSettings.IsGridStretchModeEnable = reportViewContext.IsGridStretchModeEnable;
      reportGridSettings.RightIndicatorDisplay = reportViewContext.RightIndicatorDisplay;
    }
  } else {
    reportGridSettings.ReportGridType = reportViewerPart.reportGridStyle;
    reportGridSettings.GridIconType = reportViewerPart.gridIconType;
    reportGridSettings.IsAlternateRowsBackground = reportViewerPart.isAlternateRowsBackground;
    reportGridSettings.SelectedRowsStyle = reportViewerPart.selectedRowsStyle;
    reportGridSettings.NewGridActionType = reportViewerPart.newGridActionType;
    reportGridSettings.ActionButtonName = reportViewerPart.actionButtonName;
    reportGridSettings.RowLeftClickActionType = reportViewerPart.rowLeftClickActionType;
    reportGridSettings.RowRightClickActionType = reportViewerPart.rowRightClickActionType;
    reportGridSettings.IsRowNumerationEnable = reportViewerPart.isRowNumerationEnable;
    reportGridSettings.ShowSelectedRowIndicator = reportViewerPart.showSelectedRowIndicator;
    reportGridSettings.IsGroupingEnable = reportViewerPart.isGroupingEnable;
    reportGridSettings.IsSortingEnable = reportViewerPart.isSortingEnable;
    reportGridSettings.IsGridStretchModeEnable = reportViewerPart.isGridStretchModeEnable;
    reportGridSettings.RightIndicatorDisplay = reportViewerPart.rightIndicatorDisplay;
  }

  //Grouping field name hierarchy
  if (reportViewerPart.showGroupTitle == ShowGroupTitleReportOptions.Default) {
    if (reportViewContext.ShowGroupTitle == ShowGroupTitleReportOptions.Default) {
      //ShowGroupTitleDefaultOptions
      if (designerSettings?.ShowGroupTitle == ShowGroupTitleDefaultOptions.NotOnSingleGrouping)
        reportGridSettings.ShowGroupTitle = ShowGroupTitleReportOptions.NotOnSingleGrouping;
      else if (designerSettings?.ShowGroupTitle == ShowGroupTitleDefaultOptions.Never)
        reportGridSettings.ShowGroupTitle = ShowGroupTitleReportOptions.Never;
      else reportGridSettings.ShowGroupTitle = ShowGroupTitleReportOptions.Always;
    } else reportGridSettings.ShowGroupTitle = reportViewContext.ShowGroupTitle;
  } else reportGridSettings.ShowGroupTitle = reportViewerPart.showGroupTitle;
  //Can add columns hierarchy
  if (!isDrillDown) {
    if (reportViewerPart.canAddColumns == null) {
      if (reportViewContext.AddColumnsOption == null) {
        reportGridSettings.CanAddColumns = designerSettings?.CanAddColumns;
      } else reportGridSettings.CanAddColumns = reportViewContext.AddColumnsOption;
    } else reportGridSettings.CanAddColumns = reportViewerPart.canAddColumns;
  }

  reportGridSettings.CanRenderGrid = reportViewContext.Configuration?.Columns.length > 0;
  reportGridSettings.AllowAdjustingColumnProperties = reportViewerPart.allowAdjustingColumnProperties;

  if (reportViewerPart.showReportHeaderConfigurationButton !== null)
    reportGridSettings.ShowReportHeaderConfigurationButton = reportViewerPart.showReportHeaderConfigurationButton;
  else reportGridSettings.ShowReportHeaderConfigurationButton = designerSettings?.ShowReportHeaderConfigurationButton;

  reportGridSettings.ReportRowNumbering = designerSettings?.ReportRowNumbering;
  reportGridSettings.CanAddMultipleColumns = reportViewContext.CanAddMultipleColumns;
  reportGridSettings.hideMaximizeButton = hideMaximizeButton || isDrillDown;
  return reportGridSettings;
}

export function getReportTextOutputType(viewName: string): ReportTextOutputType {
  if (viewName == 'Data') return ReportTextOutputType.Data;
  if (viewName == 'Matrix') return ReportTextOutputType.Matrix;
  if (viewName == 'Tiles') return ReportTextOutputType.Tiles;
  if (viewName == 'Rich Text') return ReportTextOutputType.Blurb;
  if (viewName == 'Text List') return ReportTextOutputType.Text;
  if (viewName == 'Layout Based View') return ReportTextOutputType.Cells;
  if (viewName == 'Calendar') return ReportTextOutputType.Calendar;
  if (viewName == 'Hierarchical View') return ReportTextOutputType.Hierarchical;
  if (viewName == 'Columns') return ReportTextOutputType.Columns;
  if (viewName == 'Charts') return ReportTextOutputType.Charts;

  return ReportTextOutputType.Default;
}

export function getReportTextOutputTypeFromReportViewType(view: ReportView): ReportTextOutputType {
  if (view == ReportView.Data) return ReportTextOutputType.Data;
  if (view == ReportView.Matrix) return ReportTextOutputType.Matrix;
  if (view == ReportView.Tiles) return ReportTextOutputType.Tiles;
  if (view == ReportView.Blurb) return ReportTextOutputType.Blurb;
  if (view == ReportView.Text) return ReportTextOutputType.Text;
  if (view == ReportView.Cells) return ReportTextOutputType.Cells;
  if (view == ReportView.Calendar) return ReportTextOutputType.Calendar;
  if (view == ReportView.HierarchicalView) return ReportTextOutputType.Hierarchical;
  if (view == ReportView.ColumnsView) return ReportTextOutputType.Columns;
  if (view == ReportView.Charts) return ReportTextOutputType.Charts;

  return ReportTextOutputType.Default;
}

export function getSelectedViews(
  selectedReportViews: string[],
  selectedView: ReportTextOutputType,
  defaultView: ReportView,
  hasMatrix: boolean,
  hasBlurbSummary: boolean,
  hasTextSummary: boolean,
  hasTiles: boolean,
  hasCalendar: boolean,
  showCellsTemplate: boolean,
  hasCharts: boolean,
  charts: ChartInfo[],
  hasHierarchicalView: boolean,
  hasColumnsView: boolean,
  isDrillDown: boolean
) {
  let selectedViewItems: ReportHeaderViewItem[] = [];
  let views = [
    ...selectedReportViews.map(item => {
      return getReportTextOutputType(item);
    }),
    selectedView,
    getReportTextOutputTypeFromReportViewType(defaultView),
  ];

  if (views.includes(ReportTextOutputType.Data)) {
    selectedViewItems.push({
      className: 'data',
      title: 'Data',
      viewName: 'Data',
      viewType: ReportTextOutputType.Data,
    });
  }
  if (views.includes(ReportTextOutputType.Matrix) && hasMatrix) {
    selectedViewItems.push({
      className: 'matrix',
      title: 'Matrix',
      viewName: 'Matrix',
      viewType: ReportTextOutputType.Matrix,
    });
  }
  if (views.includes(ReportTextOutputType.Blurb) && hasBlurbSummary) {
    selectedViewItems.push({
      className: 'richtext',
      title: 'Rich Text',
      viewName: 'Rich Text',
      viewType: ReportTextOutputType.Blurb,
    });
  }
  if (views.includes(ReportTextOutputType.Text) && hasTextSummary) {
    selectedViewItems.push({
      className: 'text',
      title: 'Text List',
      viewName: 'Text List',
      viewType: ReportTextOutputType.Text,
    });
  }
  if (views.includes(ReportTextOutputType.Tiles) && hasTiles) {
    selectedViewItems.push({
      className: 'tiles',
      title: 'Tiles',
      viewName: 'Tiles',
      viewType: ReportTextOutputType.Tiles,
    });
  }
  if (views.includes(ReportTextOutputType.Calendar) && hasCalendar) {
    selectedViewItems.push({
      className: 'calendar',
      title: 'Calendar',
      viewName: 'Calendar',
      viewType: ReportTextOutputType.Calendar,
    });
  }
  if (views.includes(ReportTextOutputType.Cells) && showCellsTemplate) {
    selectedViewItems.push({
      className: 'cells',
      title: 'Layout Based View',
      viewName: 'Layout Based View',
      viewType: ReportTextOutputType.Cells,
    });
  }
  if (views.includes(ReportTextOutputType.Charts) && (hasCharts || charts.length) && isDrillDown === false) {
    selectedViewItems.push({
      className: 'charts',
      title: 'Chart',
      viewName: 'Charts',
      viewType: ReportTextOutputType.Charts,
    });
  }
  if (views.includes(ReportTextOutputType.Hierarchical) && hasHierarchicalView) {
    selectedViewItems.push({
      className: 'hierarchical',
      title: 'Hierarchical View',
      viewName: 'Hierarchical View',
      viewType: ReportTextOutputType.Hierarchical,
    });
  }
  if (hasColumnsView) {
    selectedViewItems.push({
      className: 'columns',
      title: 'Columns View',
      viewName: 'ColumnsViewName',
      viewType: ReportTextOutputType.Columns,
    });
  }
  return selectedViewItems;
}

export interface IRuntimeFilterChangedMessage {
  FilterName: string;
  PropertyName: string;
  Value: any;
}

export interface IRuntimeFilterChangedMessageSet {
  FolderId: string;
  Messages: IRuntimeFilterChangedMessage[];
}

const RUNTIME_FILTER_SUBSCRIBER_ID = 'report-runtime-filters';

/**
 * Update runtime filter subscriptions, so they are tied to the active folder.
 * @param folderId to subscribe to
 * @param previousFolderId to unsubscribe from
 */
export function updateRuntimeFilterSubscriptions(folderId: string, previousFolderId = '') {
  if (folderId === previousFolderId) {
    return;
  }

  // unregister previous folder
  previousFolderId && unRegisterForEventAndUnsubscribe(previousFolderId, RUNTIME_FILTER_SUBSCRIBER_ID);

  // previous
  registerForEventAndSubscribe(folderId, RUNTIME_FILTER_SUBSCRIBER_ID, event => {
    const { FolderId, Values } = event.detail;
    const messages: IRuntimeFilterChangedMessageSet = {
      FolderId: FolderId,
      Messages: [],
    };

    if (!Values || !Values.length) {
      return; // bail out early if there's nothing to do
    }

    (Values as DataPair[])?.forEach(({ Name, OutputValue }) => {
      let Value = OutputValue;
      // some specific handling of dates here, returning a formatted string or a JS Date
      if (isDotNetJSONDate(OutputValue)) {
        // convert /Date to javascript date, previously we were converting it to string // TODO is this still true? can we drop this cruft?
        var momObj = getMomentFromString(OutputValue);
        if (momObj.isValid()) {
          Value = momObj.format();
        } else {
          Value = getMoment()(OutputValue).toDate();
        }
      }
      messages.Messages.push({
        FilterName: Name,
        PropertyName: 'Value',
        Value,
      });
    });

    sendClientEventNotification('RuntimeFilterBus', messages);
  });
}

export function getReportNavigationParams() {
  const { object } = getNavigationParams(location.search, true);
  let navigationParameters: { [key: string]: string | null } = {};
  Object.keys(object).forEach(key => {
    navigationParameters[key] = object[key] === 'null' ? null : object[key];
  });
  return navigationParameters;
}
